<template>
  <div>
    <loading
        :active.sync="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <Header/>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card class="bCardGlobalXL">
      <div class="text-left mt-4">
        <p style="color: #0069A9; font-weight: 600;">Gestión para Banner de Entregable PTI</p>
      </div>
      <div class="text-left mt-4">
        <p style="color: #62B6C2; font-weight: 600;">Archivo multimedia</p>
      </div>
      <div class="text-left mt-4">
        <p style="color: #5A5A5A; font-weight: 400;">Arrastra y suelta tus archivos aquí o haz clic en el botón para seleccionarlos.</p>
      </div>
      <div class="text-left mt-4">
        <input
            type="file"
            ref="fileInput"
            accept=".jpg,.png"
            style="display: none"
            @change="onFileChange"
        />
        <b-button variant="outline-info" class="rounded-pill" @click="$refs.fileInput.click()" :disabled="imagenBanner.url !==null" size="sm" >Subir archivo <i class="fa fa-plus"  aria-hidden="true"></i> </b-button>
      </div>
      <div  class="drag-and-drop"
            ref="dropArea"
            :class="{ highlight: isDraggingOver }"
            @dragenter.prevent="onDragEnter"
            @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave"
            @drop.prevent="onDrop">

        <div class="content" v-if="imagenBanner.url == null">
          <em class="subirImagenGris" style="width: 53px; height: 53px"></em>
          <p style="font-size: 12px; font-weight: 500">Únicamente se admiten archivos con las extensiones .jpg, .png </p>
        </div>

        <div v-else class="imagesPreview">
          <div class="preview_item">
            <div style="position: relative" >
              <div>
                <img :src="imagenBanner.url" :alt="'banner'" class="imgPreview"  />
              </div>
              <em class="close_outline_svg eliminar_item"  @click="eliminarArchivo(imagenBanner)" v-b-tooltip.hover.v-light title="Eliminar imagen"></em>
            </div>
            <span class="preview_item_name">{{ imagenBanner.nombreArchivo }}</span>
          </div>
        </div>

      </div>
      <div v-show="mensajesError.length > 0" class="mt-2 mensajes_error_container">
        <div v-for="(item, index) in mensajesError" :key="index" >
          <span style="color: #FEA246; font-size: 12px;">{{ item }}</span>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-center">
        <b-button variant="info" class="rounded-pill" @click="guardarBanner" :disabled="(loaderGuardar || imagenBanner.urlImagen !== null) || imagenBanner.url == null"> <b-spinner small v-if="loaderGuardar"></b-spinner> Guardar</b-button>
      </div>
    </b-card>

  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {AwsService} from "@/apiServices/aws/AwsService";
import {DeleteObjectCommand, DeleteObjectsCommand, S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";
import moment from "moment";

export default {
  name: "GestionBannerPTI",
  components: {
    Header
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    dragCounter: 0, // para evitar que se desactive cuando entras/sales de elementos hijos
    isDraggingOver: false,
    maxSize: 25 * 1024 * 1024, // 25MB
    acceptedTypes: ['image/jpeg', 'image/png'],
    mensajesError:[],
    imagenBanner: {
      idArchivo: null,
      nombreArchivo: null,
      extension: null,
      mime: null,
      url: null,
      urlImagen: null,
    },
    token: null,
    rutaBase: null,
    awsServicio: new AwsService(),
    loader: false,
    loaderGuardar: false,
  }),
  computed: {

  },
  async created() {
    this.nombreTratamiento = this.$route.params.tratamiento
    this.rutaBase = `BANNER_PTI`; // Eje: ARGUMENTARIO/TRATAMIENTO RESINA CLASE I (5183)
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWSGenerico();
    await this.validarTokenAWS();
    this.obtenerBanner();
  },
  methods: {
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAccesoGenerico().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWSGenerico(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAccesoGenerico().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWSGenerico(this.token)
        })
      }
    },

    obtenerBanner() {
      this.loader = true;

      this.$http.get(this.$api + 'archivos/banner/obtener')
          .then(response => {
            const data = response.data?.data;

            if (data) {
              this.imagenBanner.idArchivo = data.idArchivo;
              this.imagenBanner.nombreArchivo = data.nombreArchivo;
              this.imagenBanner.url = data.urlImagen;
              this.imagenBanner.urlImagen = data.urlImagen;
            } else {
              this.imagenBanner = {
                idArchivo: null,
                nombreArchivo: null,
                extension: null,
                mime: null,
                url: null,
                urlImagen: null,
              };
            }
          })
          .catch(error => {
            console.error(error);
            this.imagenBanner = {
              idArchivo: null,
              nombreArchivo: null,
              extension: null,
              mime: null,
              url: null,
              urlImagen: null,
            };
          })
          .finally(() => {
            this.loader = false; // Siempre se apaga
          });
    },


    //Funcionalidad Drag - Drop
    onDragEnter() {
      this.dragCounter++;
      this.isDraggingOver = true;
    },
    onDragOver(e) {
      e.preventDefault();
    },
    onDragLeave() {
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDraggingOver = false;
      }
    },
    onDrop(e) {
      this.dragCounter = 0;
      this.isDraggingOver = false;
      const file = e.dataTransfer.files[0]; // solo el primero
      if (file) {
        this.handleFile(file);
      }
    },
    onFileChange(e) {
      const file = e.target.files[0]; // Solo el primer archivo
      if (file) {
        this.handleFile(file);
      }
      this.$refs.fileInput.value = ''; // reset input
    },

    handleFile(file) {
      if (this.imagenBanner.idArchivo) {
        this.mostrarMensajeError(`Ya tiene una imagen cargada: ${this.imagenBanner.nombreArchivo}` );
        return;
      }
      // Validar tipo
      if (!this.acceptedTypes.includes(file.type)) {
        this.mostrarMensajeError(`Archivo no permitido: ${file.name}`);
        return;
      }

      // Validar tamaño
      if (file.size > this.maxSize) {
        this.mostrarMensajeError(`El archivo ${file.name} excede los 25MB.`);
        return;
      }

      // Crear objeto URL para leer dimensiones
      const url = URL.createObjectURL(file);
      const img = new Image();

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        // Validar dimensiones exactas
        if (width !== 755 || height !== 190) {
          this.mostrarMensajeError(
              `El banner debe tener exactamente 755px de ancho y 190px de alto. El archivo "${file.name}" tiene ${width}px x ${height}px.`
          );
          URL.revokeObjectURL(url); // Liberar memoria
          return;
        }

        // Si pasa validaciones, asignar imagen
        const extension = file.name.split('.').pop().toLowerCase();
        this.imagenBanner = {
          file,
          url,
          nombreArchivo: file.name,
          extension,
          mime: file.type,
          urlImagen: null,
        };
      };

      img.onerror = () => {
        this.mostrarMensajeError(`No se pudo leer la imagen: ${file.name}`);
        URL.revokeObjectURL(url);
      };

      img.src = url;
    },



    mostrarMensajeError(error) {
      this.mensajesError.push(error);

      setTimeout(() => {
        this.mensajesError = [];
      }, 10000);
    },


    async guardarBanner() {
      await this.validarTokenAWS();
      this.loaderGuardar = true;

      let archivoNuevo = null;
      if (this.imagenBanner) {
        archivoNuevo = this.imagenBanner;
      }

      let archivoSubido = null;

      try {
        // 1. Subir archivo si hay
        if (archivoNuevo) {
          archivoSubido = await this.guardarBannerAWS();
          if (!archivoSubido) {
            throw new Error("Error al subir archivo a AWS");
          }
        }

        // 2. Guardar en el backend
        const resultado = await this.guardarBannerBack();

        if (!resultado.ok) {
          if (archivoSubido) {
            await this.rollbackArchivos([archivoSubido]);
          }
          throw new Error("Error al guardar en el backend");
        }

        // 3. Éxito
        this.$swal({
          icon: "success",
          title: "Genial",
          text: "Se guardó correctamente",
          showConfirmButton: false,
          timer: 1500,
        });

        this.obtenerBanner();

        this.loaderGuardar = false;

      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error al guardar el banner",
          text: error.message || "Error inesperado",
        });
        this.loaderGuardar = false;
      }
    },

    async guardarBannerAWS() {
      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        if (!this.imagenBanner) {
          return null; // No hay archivo nuevo
        }

        const filePath = `${this.rutaBase}/${this.imagenBanner.nombreArchivo}`;
        const input = {
          Bucket: this.token.nombreBucket,
          Key: filePath,
          Body: this.imagenBanner.file,
          ContentType: this.imagenBanner.file.type,
          ACL: 'public-read',
        };

        const upload = new Upload({
          client,
          params: input,
          partSize: 5 * 1024 * 1024,
          queueSize: 4,
        });

        upload.on("httpUploadProgress", (progress) => {
          const porcentaje = Math.round((progress.loaded / progress.total) * 100);
          this.$set(this.imagenBanner, "progreso", porcentaje);
        });

        await upload.done();
        this.imagenBanner.url = filePath;
        this.imagenBanner.urlImagen = `https://${this.token.nombreBucket}.s3.${this.token.regionBucket}.amazonaws.com/${filePath}`;

        return filePath; // Retorna la ruta subida

      } catch (error) {
        console.error("Error en la subida a S3:", error);
        this.$swal({
          icon: "error",
          title: "Error en la subida a S3",
          text: error.message,
        });
        throw error;
      }
    },

    async guardarBannerBack() {

      try {
        const respuesta = await this.$http.post(this.$api + 'archivos/banner/guardar', this.imagenBanner);
        this.guardando = false;

        if (respuesta.data && respuesta.data.data) {
          return { ok: true };
        } else {
          return { ok: false };
        }
      } catch (error) {
        console.error("Error al guardar en backend:", error);
        throw new Error("Error al guardar en el backend");
      }
    },

    async rollbackArchivos(archivosSubidos) {
      if (!archivosSubidos || archivosSubidos.length === 0) return;

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        const deleteParams = {
          Bucket: this.token.nombreBucket,
          Delete: {
            Objects: archivosSubidos.map((filePath) => ({ Key: filePath })),
          },
        };

        const deleteCommand = new DeleteObjectsCommand(deleteParams);
        await client.send(deleteCommand);

        console.log("Rollback exitoso: archivos eliminados de S3.");
      } catch (error) {
        console.warn("Error en rollbackArchivos:", error);
      }
    },

    async eliminarArchivo() {
      const archivo = this.imagenBanner;

      const resultado = await this.$swal.fire({
        title: '¿Estás seguro?',
        text: 'Este archivo se eliminará permanentemente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (!resultado.isConfirmed) return;

      if (archivo.url) URL.revokeObjectURL(archivo.url);

      this.imagenBanner = {
        idArchivo: null,
        nombreArchivo: null,
        urlImagen: null,
        url: null,
        extension: null,
        mime: null
      }

      if (archivo.idArchivo) {
        try {
          // 1. Primero desactivar en BD
          const desactivado = await this.desactivarEnBaseDeDatos(archivo);

          // 2. Solo si BD fue exitoso, borrar de S3
          if (desactivado) {
            await this.eliminarDeAWS(archivo);
          }
        } catch (error) {
          console.error("Error en eliminación:", error);
          await this.$swal.fire(
              'Error',
              'Ocurrió un error al eliminar el archivo. Intenta de nuevo.',
              'error'
          );
        }
      }else{
        await this.$swal.fire({
          title: 'Éxito',
          text: 'Archivo eliminado correctamente.',
          icon: 'success',
        });
      }
    },

    async desactivarEnBaseDeDatos(archivo) {
      try {
        const response = await this.$http.post(
            `${this.$api}archivos/banner/inactivar`,
            { idArchivo: archivo.idArchivo }
        );

        return response.status === 200;
      } catch (error) {
        console.error("Falló desactivación en BD:", error);
        return false;
      }
    },

    async eliminarDeAWS(archivo) {
      await this.validarTokenAWS();

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      let rutaEliminar = archivo.urlImagen.replace(/^https?:\/\/[^/]+\/(.+)$/, '$1');
      console.log(rutaEliminar);
      try {
        const deleteCommand = new DeleteObjectCommand({
          Bucket: this.token.nombreBucket,
          Key: rutaEliminar, // Asegúrate que esta propiedad es correcta
        });

        await client.send(deleteCommand);
        console.log("Archivo eliminado de S3");
        await this.$swal.fire({
          title: 'Éxito',
          text: 'Archivo eliminado correctamente.',
          icon: 'success',
        });
      } catch (error) {
        console.error("Error eliminando de S3:", error);
        console.error("Error en eliminación:", error);
        await this.$swal.fire(
            'Error',
            'Ocurrió un error al eliminar el archivo de S3. Intenta de nuevo.',
            'error'
        );
      }
    },

  }
}
</script>

<style scoped>
.drag-and-drop {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.content{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
}

.drag-and-drop.highlight {
  background-color: #f0f8ff;
  border-color: #4a90e2;
  border-radius: 12px;
}

.imagesPreview{
  display: flex;
  padding: 8px 0;
  justify-content: center;
}

.imgPreview  {
  border-radius: 5px;
  object-fit: cover;
  position: relative;
}


.preview_item{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.preview_item_name{
  padding: 0.5rem;
  word-break: break-word;
  color: #5D5D5D;
  font-size: 10px;
}

.eliminar_item{
  position: absolute;
  right: -5px;
  top: -5px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.mensajes_error_container{
  transition: all 0.5s ease;
}

</style>